import { useState } from 'react';

import { SchemaRefModel } from '../../Models/DomainServiceModel';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';
import { SchemaInputDialog } from './SchemaInputDialog';

type SchemaInputProps = {
	schemaRef: SchemaRefModel | undefined;
	onSchemaRefChange: (schemaRef: SchemaRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function SchemaInput({ schemaRef, onSchemaRefChange, isEditable = true }: SchemaInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={schemaRef} />;
	}

	return (
		<GenericPropertyInput value={schemaRef} onValueChange={onSchemaRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={schemaRef} />
			{open && <SchemaInputDialog open={open} setOpen={setOpen} schemaRef={schemaRef} onSchemaRefChange={onSchemaRefChange} />}
		</GenericPropertyInput>
	);
}
